<template>
  <div id="app">
    <keep-alive :include="appKeepAlive">
      <router-view :key="appRouterKey" />
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: 'App',
  computed: {
    appKeepAlive() {
      return ['MainTab', 'login']
    },
    appRouterKey() {
      const loginFlowPaths = ['/login', '/userAgreement', '/privacyPolicy']
      return loginFlowPaths.includes(this.$route.path) ? 'login-flow' : 'main'
    },
  },
  created() {
    // 判断本地是否有存储登录信息，如果有登录信息则判断是否超过了10天，超过10天后则登录失效清空登录信息
    this.checkLoginExpire();
  },
  mounted() {

  },
  methods: {
    // 判断本地是否有存储登录信息，如果有登录信息则判断是否超过了10天，超过10天后则登录失效清空登录信息
    checkLoginExpire() {
      const raw = localStorage.getItem('userInfo')
      if (raw) {
        try {
          const userInfo = JSON.parse(raw)
          const loginTime = userInfo.loginTime
          const TEN_DAYS = 10 * 24 * 60 * 60 * 1000
          // 无 loginTime 或已超过 10 天 → 清空，视为未登录
          if (!loginTime || Date.now() - loginTime > TEN_DAYS) {
            localStorage.removeItem('userInfo')
            localStorage.removeItem('pendingReviewCount')
            // 如有单独存的 token / openid 登录相关项，一并清
            // localStorage.removeItem('openid')
            console.log('登录信息已过期，已清空')
          }
        } catch (e) {
          localStorage.removeItem('userInfo')
          localStorage.removeItem('pendingReviewCount')
        }
      }
    },

  },
}
// 禁止页面缩放
window.onload = function() {
    document.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    })
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault()
    })
}
</script>

<style>
*{
  margin:0;
  padding:0;
  border:0;
  /* 屏蔽iOS设备浏览器的字体大小修改设置 */
  -webkit-text-size-adjust   : 100% !important;
	text-size-adjust           : 100% !important;
	-moz-text-size-adjust      : 100% !important;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
